import React from "react";
import "../css/Grid.css";
import VanillaPost from "./VanillaPost.js";
import PostWithModal from "./PostWithModal.js";

const Post = React.forwardRef(({ post, user }, ref) => {
    let sizedUrl;
    if (post.id.toLowerCase().startsWith('tiktok')) {
        sizedUrl = post.app_thumbnail_url;
    }

    else if (post.id.toLowerCase().startsWith('media')) {
        if (user.igAspectRatio === '1_1') {
            sizedUrl = post.app_thumbnail_url_1_1;
        }

        if (user.igAspectRatio === '3_4') {
            sizedUrl = post.app_thumbnail_url_3_4;
        }
    }


    const APP_DOMAIN = `https://${process.env.REACT_APP_DOMAIN}`;
    const imageUrl = sizedUrl.replace(
    /^https:\/\/[^/]+/,
    APP_DOMAIN
  );
  post.imageUrl = imageUrl;



  if (post.displayType === 2) {
    return <PostWithModal post={post} user={user} ref={ref} />;
  }
  return <VanillaPost post={post} user={user} ref={ref} />;
});

export default Post;
